import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import GuestWedding from "@/pages/GuestWedding";
import LiveWall from "@/pages/LiveWall";
import { Navigate, useParams } from "react-router-dom";
import Login from "@/pages/Login";
import About from "@/pages/About";
import ForgotPassword, { ResetPassword } from "@/pages/PasswordReset";
import CreateWedding from "@/pages/CreateWedding";
import InviteAccept from "@/pages/InviteAccept";
import CoupleHome from "@/pages/CoupleHome";
import ManageWedding from "@/pages/ManageWedding";
import AdminDashboard from "@/pages/AdminDashboard";
import Legal from "@/pages/Legal";

function OldSlideshow() {
  const { slug } = useParams();
  return <Navigate to={`/poroka/${slug}`} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/poroka/:slug" element={<GuestWedding />} />
            <Route path="/poroka/:slug/projekcija" element={<OldSlideshow />} />
            <Route path="/zaslon/:token" element={<LiveWall />} />
            <Route path="/prijava" element={<Login />} />
            <Route path="/pozabljeno-geslo" element={<ForgotPassword />} />
            <Route path="/ponastavi-geslo/:token" element={<ResetPassword />} />
            <Route path="/ustvari" element={<CreateWedding />} />
            <Route path="/povabilo/:token" element={<InviteAccept />} />
            <Route path="/pravno/:doc" element={<Legal />} />
            <Route path="/o-naju" element={<About />} />
            <Route path="/nadzorna-plosca" element={<RequireAuth><CoupleHome /></RequireAuth>} />
            <Route path="/nadzorna-plosca/:wid" element={<RequireAuth><ManageWedding /></RequireAuth>} />
            <Route path="/admin" element={<RequireAuth role="admin"><AdminDashboard /></RequireAuth>} />
            <Route path="/admin/poroka/:wid" element={<RequireAuth role="admin"><ManageWedding admin /></RequireAuth>} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
